import React from 'react';
import { observer } from 'mobx-react-lite';
import GameResults from '../../conatiners/gameResults';
import { AllStatistics } from './allStatistics';

export const BetShopStatistics = observer(() => {
  return (
    <div className='bb-bet-section'>
      <div className='bb-bet-section-inside'>
        <GameResults />
        <AllStatistics />
      </div>
    </div>
  );
});
